import { render, staticRenderFns } from "./intersectionobserver.vue?vue&type=template&id=74178dd5&"
import script from "./intersectionobserver.vue?vue&type=script&lang=js&"
export * from "./intersectionobserver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports